import { CLOUD_API_URL } from '../config/serverConfig';
import { SIGNAL_PATH_NUDGE_SUPPRESS_MS } from './signalPath';

const LS_KEY = 'maestro_signal_path_nudge_dismissed_at';

function getToken(): string | null {
  try {
    const raw = localStorage.getItem('maestro_auth');
    if (raw) return JSON.parse(raw)?.accessToken || null;
  } catch { /* ignore */ }
  return null;
}

export function readNudgeDismissedAtLocal(): number | null {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return null;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

function writeNudgeDismissedAtLocal(ts: number): void {
  try {
    localStorage.setItem(LS_KEY, String(ts));
  } catch { /* ignore */ }
}

export function isSignalPathNudgeSuppressed(nowMs = Date.now()): boolean {
  const dismissedAt = readNudgeDismissedAtLocal();
  if (!dismissedAt) return false;
  return nowMs - dismissedAt < SIGNAL_PATH_NUDGE_SUPPRESS_MS;
}

export function persistSignalPathNudgeDismissal(ts = Date.now()): void {
  writeNudgeDismissedAtLocal(ts);
  const token = getToken();
  if (!token) return;
  fetch(`${CLOUD_API_URL}/api/user/preferences`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ signal_path_nudge_dismissed_at: new Date(ts).toISOString() }),
  }).catch(() => {});
}

/** Merge server preference when available (server wins over stale local cache). */
export async function hydrateSignalPathNudgeDismissal(): Promise<void> {
  const token = getToken();
  if (!token) return;
  try {
    const res = await fetch(`${CLOUD_API_URL}/api/user/preferences`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return;
    const prefs = await res.json();
    const remote = prefs?.signal_path_nudge_dismissed_at;
    if (!remote) return;
    const remoteMs = Date.parse(String(remote));
    if (!Number.isFinite(remoteMs)) return;
    const local = readNudgeDismissedAtLocal();
    if (!local || remoteMs > local) {
      writeNudgeDismissedAtLocal(remoteMs);
    }
  } catch { /* ignore */ }
}
